import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ReportsPage } from '@/features/reports';

export const Route = createFileRoute('/_app/reports/')({
  staticData: { crumb: 'nav.reports' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'report.view', 'Reports'),
  component: ReportsPage,
});
